import type { ShopLocale } from '../../../i18n/shopLocale'

export const resolveLocaleFallback = ({
  activeLocale,
  canonicalLocale,
}: {
  activeLocale?: ShopLocale
  canonicalLocale: ShopLocale
}) =>
  activeLocale && activeLocale !== canonicalLocale
    ? {
        policy: 'default-locale-content' as const,
        requestedLocale: activeLocale,
        resolvedLocale: canonicalLocale,
      }
    : undefined
